<input
    #writeComponent
    (focusout)="onBlur()"
    (input)="onValueChange($event)"
    *ngIf="editing"
    [value]="model[path]"
    class="writable-input"
    type="number"
/>
<label #readComponent (click)="onEdit()" *ngIf="!editing" [class.readable-input]="!isReadOnly">{{
    model && model[path] ? model[path] : "..."
}}</label>
